export interface IInputEvent {
  value: Event;
  name: string;
}
